import * as React from 'react';
import { map, get } from 'lodash';
import { Tabs, Tab } from 'material-ui';

export const getLoadedTabValues = (loadedTabValues: any[], activeTab: any) =>
  loadedTabValues.indexOf(activeTab) === -1 ? [...loadedTabValues, activeTab] : loadedTabValues;

class TabsContainer extends React.Component<any, { loadedTabValues: any[] }> {
  constructor(props: any) {
    super(props);
    this.state = { loadedTabValues: [props.value === undefined ? 0 : props.value] };
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.lazy && this.props.value !== prevProps.value) {
      const activeTab = this.props.value === undefined ? 0 : this.props.value;
      const loadedTabValues = getLoadedTabValues(this.state.loadedTabValues, activeTab);
      if (loadedTabValues !== this.state.loadedTabValues) {
        this.setState({ loadedTabValues });
      }
    }
  }

  render() {
    const { items, value, lazy, ...rest } = this.props;
    const { loadedTabValues } = this.state;
    const activeTab = value === undefined ? 0 : value;
    return (
      <Tabs
        {...{
          value: activeTab,
          tabItemContainerStyle: { overflowX: 'auto' },
          inkBarStyle: { height: 0 },
          ...rest
        }}
      >
        {map(items, ({ style, content, ...props }, key) => {
          const tabValue = get(props, 'value', key);
          const isLoaded = !lazy || loadedTabValues.indexOf(tabValue) !== -1;
          return (
            <Tab
              {...{
                key,
                value: key,
                style: tabValue === activeTab ? { ...style, ...{ color: '#ec7d23' } } : style,
                ...props
              }}
            >
              {isLoaded && content}
            </Tab>
          );
        })}
      </Tabs>
    );
  }
}

export default TabsContainer;



// WEBPACK FOOTER //
// ./src/components/tabs/Tabs.tsx